import React from "react"
import { Link } from "gatsby"

import Skills from "../components/skills"

const AboutText = props => (
  <>
    <p>
      <span className="text-highlight">Hello - I’m Steve</span>, a senior software engineer based in the north west of England. I have {" "}
      {calculateYears(new Date(2013, 8, 8))} years of experience delivering scalable cloud and web applications. I’ve led remote teams, built CI/CD pipelines, and I specialize in Microsoft Azure and .NET
    </p>

    <p hidden>
      For a detailed professional history, please see{" "}
      <a href="https://www.linkedin.com/in/ste-baker-dev/">my LinkedIn profile</a>.
    </p>

    {props.detailed && (
      <>
        <p>
          I began tinkering with computers at the age of 10 and quickly developed a
          passion for building websites, scripts, and video games. That curiosity evolved into a career built on the
          principle: <i>"do what you love and you'll never truly work a day in your life"</i>.
          While software engineering can be demanding, I find it consistently engaging
          and rewarding.
        </p>

        <h2>Tech Stack</h2>
        <p>
          Over the years, I’ve delivered reliable, scalable solutions across multiple industries, working both in permanent roles and as a consultant. I enjoy collaborating with teams, solving complex problems, and turning ideas into well-engineered products.
          <br />
          The technologies I’m most experienced and comfortable working with include:
        </p>
        <Skills />

        <h2>Projects &amp; Clients</h2>
        <p>
          I’ve delivered solutions across multiple industries, working both in‑house
          and as a consultant.
        </p>

        <div className="row">
          <div className="col-md-6">
            <h3>Direct Employment</h3>
            <ul className="list-compact">
              <li>Liberty Gas Group</li>
              <li>DRSP Limited</li>
              <li>CarFinance247</li>
              <li>AND Digital (Consulting)</li>
              <li>TLA (TheLeadAgency)</li>
            </ul>
          </div>

          <div className="col-md-6">
            <h3>Consulting Engagements</h3>
            <ul className="list-compact">
              <li>evestor / OpenMoney</li>
              <li>TalkTalk</li>
              <li>PwC (PricewaterhouseCoopers)</li>
              <li>Lookers</li>
              <li>Co‑op Group</li>
              <li>The Prince’s Trust</li>
              <li>Sky</li>
              {/* <li>Department for Education (GOV.UK)</li> */}
            </ul>
          </div>
        </div>

        <p hidden>
          You can view a selection of my public side projects — some ongoing — in my{" "}
          <Link to="/portfolio">Portfolio</Link>.
        </p>
      </>
    )}
  </>
)

function calculateYears(startDate) {
  const diffMs = Date.now() - startDate.getTime()
  const diffDate = new Date(diffMs)
  return Math.abs(diffDate.getUTCFullYear() - 1970)
}

export default AboutText
